// The POS has no offline queue (removed in SFRESTO-168 until the offline-first
// deployment is built): an order that cannot reach the API is not saved, so
// staff must see that and resend it once the connection is back.
export const NETWORK_ERROR_MESSAGE =
  "Pas de connexion : la commande n'a pas été envoyée. Vérifiez la connexion puis réessayez.";

/** True when RTK Query could not reach the API at all (no HTTP response). */
export function isNetworkError(error: unknown): boolean {
  return (
    typeof error === "object" &&
    error !== null &&
    (error as { status?: unknown }).status === "FETCH_ERROR"
  );
}
